import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import { useTranslation } from "react-i18next";

function Projects() {
  const { t } = useTranslation();
  const projects = t('projects.list', { returnObjects: true });

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          {t('projects_header')}
        </h1>
        <p style={{ color: "white" }}>
          {t('projects_description')}
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {Array.isArray(projects) && projects.map((project, index) => (
            <Col md={4} className="project-card" key={project.id || index}>
              <ProjectCard
                imgPath={project.image}
                isSite={true}
                title={project.title}
                description={project.description}
                ghLink={project.ghLink || project.demoLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
